<template>
  <div v-if="list">
    <div class="pa-3">
      <!-- Tip 1 -->
      <div>
        <v-icon size="18">mdi-label-variant</v-icon>
        <i class="body-2 greyDarken1--text">
          {{ $t("screener.monetization.revenue.amount_update_tip") }}</i
        >
      </div>
      <!-- Tip 2 -->
      <div>
        <v-icon size="18">mdi-label-variant</v-icon>
        <i class="body-2 greyDarken1--text">
          {{ $t("screener.monetization.revenue.refund_tip") }}</i
        >
      </div>
      <!-- Tip 3 -->
      <div>
        <v-icon size="18">mdi-label-variant</v-icon>
        <i class="body-2 greyDarken1--text">
          {{ $t("screener.monetization.revenue.discounted_sales") }}</i
        >
      </div>
    </div>
    <v-layout row wrap class="pa-3">
      <v-flex xs12 sm12 md12>
        <div v-if="Object.keys(selected_screener).length">
          <v-btn
            class="mx-0"
            color="secondary"
            @click="resetScreeningSpecificRevenue()"
          >
            <v-icon left small>$vuetify.icons.screener_back</v-icon>
            {{ $t("screener.monetization.revenue.back_to_event_list") }}
          </v-btn>
          <AboutRevenue :item="selected_screener" :is_event_revenue="true" />
        </div>
        <v-flex v-else xs12 sm3 md3>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('rms.field.search') + ' By Screening'"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
      </v-flex>
    </v-layout>
    <template v-if="!Object.keys(selected_screener).length">
      <v-data-table
        :headers="table_headers"
        :loading="loading"
        :items="list"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="value"
      >
        <template slot="headerCell" slot-scope="props">
        
          <span >{{ props.header.text }}</span>
        </template>
        <template v-slot:items="props">
          <tr
            @click.stop="
              (props.expanded = !props.expanded),
                (selected_screener = props.item),
                props.expanded ? getScreeningSpecificRevenue() : ''
            "
            style="cursor: pointer"
          >
            <td class="body-2">
              <v-tooltip top color="greyDarken1">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.item.screener | truncate }}</span>
                </template>
                <span class="white--text body-1">{{
                  props.item.screener
                }}</span>
              </v-tooltip>
            </td>
            <td>
              <v-chip
                color="secondary"
                outline
                small
                v-for="film in props.item.films"
                :key="film.id"
                >{{ film.title }}</v-chip
              >
            </td>
            <td>
              <template v-if="props.item.right_holders.length">
                <v-chip
                  color="secondary"
                  outline
                  v-for="right_holder in props.item.right_holders"
                  :key="right_holder"
                  small
                  >{{ right_holder }}</v-chip
                >
              </template>
              <template v-else>---</template>
            </td>
            <td>{{ props.item.currency }}</td>
            <td>{{ props.item.total_amount | fixed }}</td>
            <td>{{ props.item.total_company_share | fixed }}</td>
            <td>{{ props.item.total_right_holder_share | fixed }}</td>
            <td>
              <v-icon color="success" v-if="props.item.is_revenue_processed"
                >$vuetify.icons.rms_check</v-icon
              >
              <v-icon color="error" v-else>$vuetify.icons.rms_close</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <template v-else xs12 sm12 md12>
      <v-data-table
        :headers="expansion_headers"
        :items="revenue"
        :loading="expansion_loading"
        :pagination.sync="expansion_pagination"
        :total-items="expansion_total"
        :rowsPerPageItems="expansion_rowsPerPageItems"
        item-key="value"
      >
        <template slot="headerCell" slot-scope="props">
          <span >{{ props.header.text }}</span>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="body-2">
              <router-link
                :to="{
                  name: 'consumer.index',
                  params: { consumer_id: props.item.consumer_id },
                }"
                >{{ props.item.consumer }}</router-link
              >
            </td>
            <td>
              <v-icon v-if="props.item.is_consumer_enrolled" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td>{{ props.item.pricing_plan }}</td>
            <td>
              {{ DEFINES.MONETIZATION.PURCHASE_TYPE[props.item.purchase_type] }}
            </td>
            <td>{{ props.item.film }}</td>
            <td>
              {{ props.item.right_holder ? props.item.right_holder : "---" }}
            </td>
            <td>
              {{
                props.item.right_holder_share_percent
                  ? props.item.right_holder_share_percent
                  : "---"
              }}
            </td>
            <td>{{ props.item.total_amount }}</td>
            <td>{{ props.item.company_share }}</td>
            <td>{{ props.item.right_holder_share }}</td>
            <td>
              <v-icon color="success" v-if="props.item.is_revenue_processed"
                >$vuetify.icons.rms_check</v-icon
              >
              <v-icon color="error" v-else>$vuetify.icons.rms_close</v-icon>
            </td>
            <td>{{ fmtTime(props.item.created_at) }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { utcToTz } from "@/helper";
import i18n from "@/i18n";
import AboutRevenue from "./AboutRevenue";

export default {
  name: "ScreeningWiseRevenue",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.listRevenueByScreenings();
    });
  },
  components: {
    AboutRevenue,
  },
  data() {
    return {
      table_headers: [
        {
          text: "Screening",
          sortable: true,
          align: "left",
          value: "screener",
        },
        {
          text: i18n.t("films.title"),
          sortable: false,
          align: "left",
          value: "films",
        },
        {
          text: i18n.t("company.dashboard.members.section.right_holders"),
          sortable: false,
          align: "left",
          value: "right_holder_email",
        },
        {
          text: i18n.t("screener.table.header.currency"),
          sortable: false,
          align: "left",
          value: "currency",
        },
        {
          text: i18n.t("screener.table.header.total_amount"),
          sortable: true,
          align: "left",
          value: "total_amount",
        },
        {
          text: i18n.t("screener.table.header.total_company_share"),
          align: "left",
          sortable: true,
          value: "total_company_share",
        },
        {
          text: i18n.t("screener.table.header.total_right_holder_share"),
          align: "left",
          value: "total_right_holder_share",
          sortable: true,
        },
        {
          text: "Paid",
          align: "left",
          value: "is_revenue_processed",
          sortable: true,
        },
      ],
      expansion_headers: [
        {
          text: i18n.t("screener.table.header.participant"),
          sortable: true,
          align: "left",
          value: "consumer",
        },
        {
          text: i18n.t("screener.table.header.participated"),
          sortable: false,
          align: "left",
          value: "is_consumer_enrolled",
        },
        {
          text: i18n.t("screener.monetization.pricing_plan"),
          sortable: false,
          align: "left",
          value: "pricing_plan",
        },
        {
          text: i18n.t("screener.table.header.plan_type"),
          sortable: false,
          align: "left",
          value: "purchase_type",
        },
        {
          text: i18n.t("screener.table.header.film"),
          sortable: false,
          align: "left",
          value: "film",
        },
        {
          text: i18n.t("film.rightholder.title"),
          sortable: true,
          align: "left",
          value: "right_holder",
        },
        {
          text: i18n.t("screener.table.header.right_holder_share_percent"),
          sortable: true,
          align: "left",
          value: "right_holder_share_percent",
        },
        {
          text: i18n.t("screener.table.header.total_amount"),
          sortable: true,
          align: "left",
          value: "total_amount",
        },
        {
          text: i18n.t("screener.table.header.company_share"),
          sortable: true,
          align: "left",
          value: "company_share",
        },
        {
          text: i18n.t("screener.table.header.right_holder_share"),
          sortable: true,
          align: "left",
          value: "right_holder_share",
        },
        {
          text: "Paid",
          align: "left",
          value: "is_revenue_processed",
          sortable: true,
        },
        {
          text: i18n.t("screener.table.header.created_at"),
          sortable: true,
          align: "left",
          value: "created_at",
        },
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "total_amount",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      expansion_pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      search: "",
      loading: false,
      total: null,
      expansion_loading: false,
      revenue: [],
      expansion_rowsPerPageItems: [5, 10, 25, 50, 100],
      expansion_total: null,
      selected_screener: {},
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.revenue.list.screeningWiseRevenue,
    }),
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
  },
  watch: {
    pagination: {
      handler: "listRevenueByScreenings",
      deep: true,
    },
    expansion_pagination: {
      handler() {
        this.getScreeningSpecificRevenue();
      },
      deep: true,
    },
  },
  methods: {
    applySearch() {
      if (this.search.length) this.listRevenueByScreenings();
    },
    clearSearch() {
      this.search = "";
      this.listRevenueByScreenings();
    },
    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, "MMM Do YYYY, h:mm a");
    },
    // It gives summary or total sum of revenue for a screening
    async listRevenueByScreenings() {
      try {
        this.loading = true;
        // Pagination
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);
        // Payload
        let payload = {
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
          sorting_order: descending,
          search: this.search,
          filters: {},
        };

        var response = await this.$store.dispatch(
          "revenue/listByScreenings",
          payload
        );

        this.total = response.screening_wise_revenue.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),

    resetScreeningSpecificRevenue() {
      this.selected_screener = {};
    },

    // Returns all records for a screener
    async getScreeningSpecificRevenue() {
      try {
        if (!Object.keys(this.selected_screener).length) {
          return;
        }
        // Resetting old data when clicking on other summary record
        this.revenue = [];
        this.expansion_loading = true;

        const {
          sortBy,
          descending,
          page,
          rowsPerPage,
        } = this.expansion_pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);

        // Payload
        let payload = {
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
          sorting_order: descending,
          screener_id: this.selected_screener.screener_id,
        };

        var response = await this.$store.dispatch("revenue/list", payload);

        this.expansion_total = response.revenue.total;
        this.revenue = response.revenue.data;
        this.expansion_loading = false;
      } catch (error) {
        this.expansion_loading = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>
